export default __webpack_public_path__ + "static/media/autarq.ab12ff79.mp4";